import React, { useEffect, useState } from 'react';
import './Waveform.css';

interface WaveformProps {
  volumeLevel?: number;
}

const Waveform: React.FC<WaveformProps> = ({ volumeLevel = 0 }) => {
  const [bars, setBars] = useState<number[]>([]);

  useEffect(() => {
    // Generate waveform bars based on volume level distribution
    const generateBars = () => {
      const newBars = Array.from({ length: 200 }, () => {
        // Create volume-based distribution
        // High volume: more bars tend to be taller
        // Low volume: more bars tend to be shorter
        
        let height;
        if (volumeLevel > 0.7) {
          // High volume: 70% chance of high bars (60-100%), 30% chance of medium (20-60%)
          height = Math.random() < 0.7 
            ? Math.random() * 40 + 60  // 60-100%
            : Math.random() * 40 + 20; // 20-60%
        } else if (volumeLevel > 0.3) {
          // Medium volume: mixed distribution
          const rand = Math.random();
          if (rand < 0.4) {
            height = Math.random() * 40 + 60; // 60-100% (40% chance)
          } else if (rand < 0.7) {
            height = Math.random() * 40 + 20; // 20-60% (30% chance)
          } else {
            height = Math.random() * 20 + 4;  // 4-24% (30% chance)
          }
        } else {
          // Low volume: 70% chance of low bars (4-30%), 30% chance of medium (20-60%)
          height = Math.random() < 0.7 
            ? Math.random() * 26 + 4   // 4-30%
            : Math.random() * 40 + 20; // 20-60%
        }
        
        return Math.max(4, Math.min(100, height));
      });
      setBars(newBars);
    };

    generateBars();
    const interval = setInterval(generateBars, 150);

    return () => clearInterval(interval);
  }, [volumeLevel]);

  return (
    <div className="waveform">
      {bars.map((height, index) => (
        <div
          key={index}
          className="waveform-bar"
          style={{ height: `${height}%` }}
        />
      ))}
    </div>
  );
};

export default Waveform;
